import React from "react";
import "./style.css"; 
import { Link } from "react-router-dom";

const ServiceSection = () => {
  const services = [
    {
      icon: "fa-laptop",
      title: "Custom Software Development",
      description:
        "We deliver innovative and scalable software solutions tailored to your business needs using modern technologies and best practices.",
    },
    {
      icon: "fa-certificate",
      title: "IT Training & Certifications",
      description:
        "Upskill with comprehensive, industry-relevant IT training courses and certifications to significantly boost your career and technical expertise.",
    },
    {
      icon: "fa-arrows-alt",
      title: "Resource Augmentation",
      description:
        "Scale your IT projects with our skilled professionals, ready to integrate seamlessly into your team for short or long-term needs.",
    },
    {
      icon: "fa-graduation-cap",
      title: "Internship Programs",
      description:
        "Get access to top-notch, industry-trained interns to drive your projects forward while mentoring the next generation of IT professionals.",
    },
    {
      icon: "fa-cloud",
      title: "IT Infrastructure Services",
      description:
        "Ensure robust and secure IT infrastructure with our end-to-end services, including cloud migration, network optimization, and maintenance.",
    },
    {
      icon: "fa-lightbulb",
      title: "Digital Transformation Consulting",
      description:
        "Transform your business processes with our strategic digital transformation solutions, ensuring sustained growth and innovation.",
    },
  ];

  return (
    <div className="container-xxl py-5 bg-light">
      <div className="container">
        <div className="text-center mb-5">
          <h1 className="display-5 fw-bold text-primary">Our Services</h1>
          <p className="text-muted">
            Empowering businesses and individuals with cutting-edge IT solutions and training programs tailored for success.
          </p>
        </div>
        <div className="row g-4">
          {services.map((service, index) => (
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay={`${0.1 * (index + 1)}s`}
              key={index}
            >
              <div className="service-item text-center shadow-sm rounded p-4">
                <div className="icon-container bg-primary text-white rounded-circle mb-4">
                  <i className={`fa ${service.icon} fa-3x`}></i>
                </div>
                <h5 className="fw-bold">{service.title}</h5>
                <p className="text-muted">{service.description}</p>
                {/* <Link to="/services" className="btn btn-outline-primary mt-3">
                  Learn More
                </Link> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServiceSection;
